<template>
    {{data}}
    <canvas class="w-full h-full" id="myChart" ></canvas>
</template>

<script>
import { onMounted, ref, watch } from '@vue/runtime-core'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

export default {
    name: 'DashChart',
    components: {
    },
    props: ['data', 'labels', 'type'],
    setup (props) {
        const myChart = ref(null)

        Chart.register(...registerables)

        watch(() => props.data, (n, o) => {
            myChart.value.destroy()
            createChart()
        })

        const chartType = ref(true)

        watch(() => props.type, (n, o) => {
            
            chartType.value = n
            myChart.value.destroy()
            createChart()
        })

        const createChart = () => {
            const ctx = document.getElementById('myChart').getContext('2d')
            myChart.value = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: !chartType.value ? ['Agendado', 'Cadastro de Loja Manual', 'Desistente', 'Importação automatizada', 'Não Atende', 'Número Errado', 'OK Cadastrado', 'Ocupado', 'Recusa Participar'] : ['Importação automatizada', 'Loja Cancelada pelo Responsável', 'Responsável ausente em todas tentativas', 'Sem venda no periodo auditado', 'Recolha em Progresso', 'Recolha Realizada'],
                    datasets: !chartType.value
                        ? [
                            {
                                label: 'Pendentes Lojas Adesão',
                                data: props.data.lojaAdesao.pendente,
                                backgroundColor: 'rgba(32, 116, 246, 0.8)',
                                stack: 'Stack 1'
                            },
                            {
                                label: 'Concluido Lojas Adesão',
                                data: props.data.lojaAdesao.concluida,
                                backgroundColor: 'rgba(34, 98, 196, 0.8)',
                                stack: 'Stack 1'
                            }
                        ]
                        : [
                            {
                                label: 'Pendentes Lojas Ativas',
                                data: props.data.lojaAtiva.pendente,
                                backgroundColor: 'rgba(71, 34, 196, 0.8)',
                                stack: 'Stack 0'
                            },
                            {
                                label: 'Concluido Lojas Ativas',
                                data: props.data.lojaAtiva.concluida,
                                backgroundColor: 'rgba(71, 34, 196, 0.8)',
                                stack: 'Stack 0'
                            }
                        ]
                },
                options: {
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                maxRotation: 90,
                                minRotation: 90
                            }
                        },
                        y: {
                            beginAtZero: true
                        }
                    },
                    maintainAspectRatio: true
                }
            })
        }

        onMounted(async () => {
            await createChart()
        })

        return {
            myChart
        }
    }

}
</script>

<style>

</style>
